<script>
import ElSwitch from 'element-ui/packages/switch/src/component'

export default {
  extends: ElSwitch,
  props: {
    activeValue: {
      type: [Boolean, String, Number],
      default: 1
    },
    inactiveValue: {
      type: [Boolean, String, Number],
      default: 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/element/ElSwitch.vue